export default function HomePageImgQuickLink () {
    return(
        <div>
<div id="carouselExampleAutoplaying" className="carousel slide carousel-fade" data-bs-ride="carousel">
    <div className="carousel-inner">
        <div className="carousel-item">
            <img src="img/backgrounds/bg1.jpg" alt="..."/>
        </div>
        <div className="carousel-item">
            <img src="img/backgrounds/bg21.jpg" alt="..."/>
        </div>
        <div className="carousel-item">
            <img src="img/backgrounds/bg24.jpg" alt="..."/>
        </div>
        <div className="carousel-item">
            <img src="img/backgrounds/bg2.jpg" alt="..."/>
        </div>
        <div className="carousel-item ">
            <img src="img/backgrounds/bg7.jpg" alt="..."/>
        </div>
        <div className="carousel-item active">
            <img src="img/backgrounds/bg18.jpg" alt="..."/>
        </div>
        <div className="carousel-item">
            <img src="img/backgrounds/bg22.jpg" alt="..."/>
        </div>
    </div>
    {/*
    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
    </button>
    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
    </button>
    */}
</div>

<div className="icon-bar mb-shadow-text" aria-label="secondary navigation">
    <a href="../police" className="button no-underline">
        <div className="icon-button-police-icon">
            <img src="../img/svg-icons/police.svg" alt="police icon" />
        </div>
        <div className="icon-button-text">Police</div>
    </a>
    <a href="../sanitation" className="button no-underline">
        <div className="icon-button-trash-icon ">
            <img src="../img/svg-icons/trash.svg" alt="trash can icon" />
        </div>
        <div className="icon-button-text">Sanitation</div>
    </a>
    <a href="../calendar" className="button no-underline">
        <div className="icon-button-calendar-icon">
            <img src="../img/svg-icons/calendar.svg" alt="calendar icon"/>
        </div>
        <div className="icon-button-text">Calendar</div>
    </a>
    <a href="../tourism" className="button no-underline">
        <div className="icon-button-tourism-icon">
            <img src="../img/svg-icons/tourism.svg" alt="Tourism icon"/>
        </div>
        <div className="icon-button-text">Tourism</div>
    </a>

    <a href="../howdoi" className="button no-underline">
        <div className="icon-button-howdoi-icon">
            <img src="../img/svg-icons/howdoi.svg" alt="how do I icon"/>
        </div>
        <div className="icon-button-text">How Do I?...</div>
    </a>
    <a href="../docs" className="button no-underline">
        <div className="icon-button-documents-icon">
            <img src="../img/svg-icons/folder-open1.svg" alt="open folder icon"/>
        </div>
        <div className="icon-button-text">Documents</div>
    </a>
</div>
</div>
)
}